module.exports = __webpack_public_path__ + "static/pistachio-8b8d9b009b30c9b5347ce99b3cabc749.svg";